function fakeLoader<T>(data: T): Promise<T> {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(data)
        }, Math.random() * 450 + 50)
    })
}

export default fakeLoader
